import { cloneElement } from 'react';
import { Draggable } from 'react-beautiful-dnd';

export default function DraggableTab({
  child,
  index,
  isDragDisabled,
  ...rest
}) {
  return (
    <Draggable
      draggableId={`${index}`}
      isDragDisabled={isDragDisabled}
      index={index}
      disableInteractiveElementBlocking>
      {({ innerRef, draggableProps, dragHandleProps }) => (
        <div
          ref={innerRef}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...draggableProps}>
          {cloneElement(child, {
            ...rest,
            ...dragHandleProps,
            style: { cursor: 'inherit' },
          })}
        </div>
      )}
    </Draggable>
  );
}
